import styled, { css } from 'styled-components';

const statusColor = css<{ $passed: boolean }>`
    color: ${({ $passed }) => ($passed ? 'var(--success-normal)' : 'var(--error-normal)')};
`;

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const BarRow = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const SegmentedBar = styled.div`
    display: flex;
    flex: 1;
    gap: 2px;
`;

export const Segment = styled.div<{ $passed: boolean }>`
    flex: 1;
    height: 6px;
    background-color: ${({ $passed }) => ($passed ? 'var(--success-normal)' : 'var(--error-normal)')};
`;

export const CountLabel = styled.span`
    flex-shrink: 0;
    font-size: 12px;
    color: var(--secondary-text);
    white-space: nowrap;
`;

export const ItemsList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const ItemRow = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 8px;
`;

export const ItemIcon = styled.span<{ $passed: boolean }>`
    ${statusColor}
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    width: 24px;
    height: 24px;
    line-height: 1.4;
    flex-shrink: 0;
`;

export const ItemTextWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

export const ItemLabel = styled.span<{ $passed: boolean }>`
    color: ${({ $passed }) => ($passed ? undefined : 'var(--error-normal)')};
    font-size: 14px;
    font-weight: 500;
`;

export const ItemMessage = styled.span`
    font-size: 12px;
    color: var(--secondary-text);
`;

export const HeaderWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const HeaderIcon = styled.span<{ $passed: boolean }>`
    ${statusColor};
    background: ${({ $passed }) => ($passed ? 'var(--polar-green-1)' : 'var(--dust-red-1)')};
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    width: 24px;
    height: 24px;
`;

export const HeaderLabel = styled.span`
    font-size: 16px;
    font-weight: 600;
`;
